import React from "react";
import { useEffect } from "react";
import './skills.css'
import { NavLink } from "react-router-dom";
import TypeWriterEffect from 'react-typewriter-effect';

export default function Skills(){
    useEffect(()=>{
        window.scrollTo({top:0, left:0, behavior:'smooth'})
    })

    return(
        <div className="skills_container ">

            <div className="skills_header container">
                <h1 className="skills_text">
                <TypeWriterEffect
                        textStyle={{ 
                            fontSize: '1.5rem',
                            color: 'green'
                        }}
                        cursorColor="green"
                        startDelay={100}
                        text="My Skills"
                        typeSpeed={100}
                        hideCursorAfterText={true}
                    />
                </h1>
                <p className="skills_desc">
                    I am a skilled and passionate software developer with a strong foundation 
                    in multiple programming languages and frameworks.I have honed my expertise in web development,
                    mobile application development,
                    Desktop application development,networking and database management. I am proficient 
                    in languages such as JavaScript, Java, c#, PHP and I have hands-on
                    experience with frameworks like React, nest, next and jquery. I am well
                    -versed in designing and implementing responsive and user-friendly 
                    interfaces, utilizing modern front-end technologies like HTML5, CSS3,
                    and Bootstrap. Additionally, I have a solid understanding of back-end
                    development, including RESTful APIs, server management, and database
                    design. I am committed to staying up-to-date with the latest
                    industry trends and continuously expanding my skill set. 
                    With a strong attention to detail and problem-solving mindset,
                    I thrive in collaborative environments like git and github and excel at delivering 
                    high-quality solutions.       
                </p>
            </div>
            
            <div className="technical_skills_container container">
                <div className="skills_bar_left">
                    <h1 className="technical_skills_container_Webdev">
                        web development and programing
                    </h1>
                    <div className="skills_bar ">
                        <div className="bar">
                            <div className="info">
                                <span>HTML</span>
                            </div>
                            <div className="progress_line progress_line_left html"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>CSS</span>
                            </div>
                            <div className="progress_line progress_line_left css"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>java</span>
                            </div>
                            <div className="progress_line java"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>C#</span>
                            </div>
                            <div className="progress_line C#"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>MySQL</span>
                            </div>
                            <div className="progress_line progress_line_left mysql"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>Javascript</span>
                            </div>
                            <div className="progress_line Javascript"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>PHP</span>
                            </div>
                            <div className="progress_line PHP"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>Git & Github</span>
                            </div>
                            <div className="progress_line Git"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>Networking</span>
                            </div>
                            <div className="progress_line Networking"><span></span></div>
                        </div>
                    </div>
                </div>
                
                <div className="skills_bar_right">
                    <h1 className="technical_skills_container_Webdev">
                        Personal Skills
                    </h1>
                    <div className="skills_bar ">
                        <div className="bar">
                            <div className="info">
                                <span>Communication</span>
                            </div>
                            <div className="progress_line Communication"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>Collaboration</span>
                            </div>
                            <div className="progress_line Collaboration"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>Problem solving</span>
                            </div>
                            <div className="progress_line Problemsolving"><span></span></div>
                        </div>   

                        <div className="bar">
                            <div className="info">
                                <span>Fast Learner</span>
                            </div>
                            <div className="progress_line Fastlearner"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>Leadership</span>
                            </div>
                            <div className="progress_line Leadership"><span></span></div>
                        </div>

                        <div className="bar">
                            <div className="info">
                                <span>Time Management</span>
                            </div>
                            <div className="progress_line Timemanagement"><span></span></div>
                        </div>
                    </div>
                </div>
                
            </div>

            <div className="edu_desc container">
                My educational journey as a computer scientist has been an 
                exciting and fulfilling experience from secondary  
                school years when I discovered my passion for technology and coding. 
                I focused on strengthening my foundation in mathematics and started exploring basic 
                programming languages, creating small projects to understand their practical applications.
                I first attended national colledge of information Technology(NACIT) where i obtained a diploma in 
                compunting with high grades. I latter on enrolled for bachelor of education in computer science which i am to complete in 2025. 
                 Along the way, i also participated in online courses of which the certifications are shown in the section below.
            </div>

            <div className="education_experience_container container">
                
                <section className="col">
                    <h2 className="education_title">
                        Education
                    </h2>

                    <div className="contents">
                        <div className="box">
                            <h4>2016 - 2018</h4>
                            <h3>Malawi School Certificate of Education(MSCE)</h3>
                            <p>
                                Obtained from Michiru View Boys Secondary school
                            </p>
                        </div>

                        <div className="box">
                            <h4>2019 - 2021</h4>
                            <h3>Level 4 Diploma in Computing</h3>
                            <p>
                                Obtained from National Collage of Information Technology (NACIT)
                            </p>
                        </div>

                        <div className="box">
                            <h4>2021 - Current</h4>
                            <h3>Pursuing Bachelor of Education in Computer Science</h3> 
                            <p>
                                Being obtained from the university of Malawi(UNIMA), Previously known as the University of Malawi Chancellor collage
                            </p>
                        </div>

                        <div className="box">
                            <h4>2022</h4>
                            <h3>Learn JavaScript And JQuery from scratch</h3>
                            <p>
                                Obtained from Eduonix, follow this link for the Certificate https://www.eduonix.com/certificate/e5daf53405
                            </p>
                        </div>

                        <div className="box">
                            <h4>2023</h4>
                            <h3>Git & GitHub – The Complete Git & GitHub Course</h3>
                            <p>
                                Obtained from Eduonix, follow this link for the Certificate https://www.eduonix.com/certificate/f87e9a1fc9
                            </p>
                        </div>
                    </div>
                </section>
                
                <section className="col">
                    <h2 className="education_title">
                        Experience
                    </h2>

                    <div className="contents">
                        <div className="box">
                            <h4>2018</h4>
                            <h3>Data Entry Cleck</h3>
                            <p>
                                Held this position at Group 4 Securicor (G4S)
                            </p>
                        </div>
                    </div>
                </section>

            </div>
            
            <div className="skill_page_btns container">
                <NavLink to="/contactme" className="skillpage_btn greenbtn">Hire Me</NavLink>
                <NavLink to="/projects" className="skillpage_btn greenbtn">My Projects</NavLink>
            </div>
        </div>

        
    )
}